import React, {useState} from 'react';
import Big from 'big.js';
import ContractForCarsLayout from './ContractForCarsLayout';
import Arrow from "../../../../assets/icons/arrow-down.svg";
import {useSelector} from "react-redux";

const TableLayout = ({ tableView, clientContract }) => {
  const check = clientContract?.positions && clientContract.positions.length !== 0;
  const sortedPositions = clientContract?.positions?.sort((a, b) => a.positionId - b.positionId);
  const [isVisible, setIsVisible] = useState(false)
  const { accessFeatures } = useSelector(({ user }) => user);

  const changeVisible = () => {
    setIsVisible(!isVisible)
  }

  return (
    <>
      {tableView === 'PURITY' && (
        <table className="table hover">
          <thead className="clientContract-table-head">
            <tr>
              <th></th>
              <th className="clientContract-table-col min tableHead" scope="col">
                <p>Наименование</p>
              </th>
              <th className="clientContract-table-col min tableHead" scope="col">
                <p>Вставки</p>
              </th>
              <th className="clientContract-table-col min" scope="col">
                <p>Доп. описание</p>
              </th>
              <th className="clientContract-table-col tableHead" scope="col">
                <p>Проба</p>
              </th>
              <th className="clientContract-table-col tableHead" scope="col">
                <p>
                  Цена <br />
                  за грамм
                </p>
              </th>
              <th className="clientContract-table-col tableHead" scope="col">
                <p>
                  Общий <br />
                  вес, г.
                </p>
              </th>
              <th className="clientContract-table-col tableHead" scope="col">
                <p>
                  Лигатурный <br />
                  вес, г.
                </p>
              </th>
              <th className="clientContract-table-col tableHead" scope="col">
                <p>
                  Оценочная <br />
                  стоимость, руб.
                </p>
              </th>
              <th className="clientContract-table-col tableHead" scope="col">
                <p>Количество</p>
              </th>
              <th className="clientContract-table-col tableHead" scope="col">
                <p>
                  Сумма <br />
                  микрозайма, руб.
                </p>
              </th>
              <th className="clientContract-table-col tableHead" scope="col">
                <p>
                  Сумма <br />к возврату, руб.
                </p>
              </th>
            </tr>
          </thead>
          <tbody className="clientContract-table-body">
            {check &&
              clientContract.positions.map((i, ind) => (
                <tr key={i.names[0] + ind}>
                  <td id="clientContractTableItem">{ind+1}</td>
                  <td id="clientContractTableItem">
                    <p>{i.names.join(' ')}</p>
                  </td>
                  <td id="clientContractTableItem" className="max">
                    <p>{i.comment}</p>
                  </td>
                  <td id="clientContractTableItem">
                    {i.additionalInfo && <p>{i.additionalInfo}</p>}
                  </td>
                  <td id="clientContractTableItem">
                    <p>
                      {i.purityType} {i.purityName}
                    </p>
                  </td>
                  <td id="clientContractTableItem">
                    <p>{i.purityPrice.toFixed(2)} руб./г.</p>
                  </td>
                  <td id="clientContractTableItem">
                    <p>{i.grossWeight.toFixed(2)}</p>
                  </td>
                  <td id="clientContractTableItem">
                    <p>{i.pureWeight.toFixed(2)}</p>
                  </td>
                  <td id="clientContractTableItem">
                    <p>{i.estimatedValue.toFixed(2)}</p>
                  </td>
                  <td id="clientContractTableItem">
                    <p>{i.quantity}</p>
                  </td>
                  <td id="styleTd"></td>
                  <td id="styleTd"></td>
                </tr>
              ))}
            {
                accessFeatures['deal.additional_info'] &&
                <tr className={'clientContract-table-row'}>
                  <td colSpan={2} className={`clientContract-table-col`} >
                    <div className={'clientContract-table-td d-flex'}>
                      <p>Комментарий</p>
                      <span className={`clientContract-table-col-arrow${
                          isVisible ? '-up' : ''
                      }`}>
                 <Arrow onClick={() => changeVisible()} />
              </span>
                    </div>
                  </td>
                </tr>
            }
            <tr className={'clientContract-table-row'}>
            <td colSpan={11}>
              <div className={`clientContract-table-line${
                  isVisible ? '-visible' : ''
              }`}>
                <p className='clientContract-text'>{clientContract.additionalInformation}</p>
              </div>
            </td>
            </tr>
          </tbody>
          <tfoot className="clientContract-table-foot">
            <tr>
              <td></td>
              <td colSpan="5">
                <p>Итого</p>
              </td>
              <td>
                <p>
                  {check &&
                    clientContract.positions
                      .map((i) => i.grossWeight)
                      .reduce((p, c) => new Big(c).plus(p), 0)
                      .toFixed(2)}
                </p>
              </td>
              <td>
                <p>
                  {check &&
                    clientContract.positions
                      .map((i) => i.pureWeight)
                      .reduce((p, c) => new Big(c).plus(p), 0)
                      .toFixed(2)}
                </p>
              </td>
              <td>
                <p>
                  {clientContract?.totalEstimatedValue &&
                    clientContract.totalEstimatedValue.toFixed(2)}
                </p>
              </td>
              <td>
                <p>
                  {check &&
                    clientContract.positions.map((i) => i.quantity).reduce((p, c) => p + c, 0)}
                </p>
              </td>
              <td>
                <p>{clientContract?.amount && clientContract.amount.toFixed(2)}</p>
              </td>
              <td>
                <p>{clientContract?.refundAmount && clientContract.refundAmount.toFixed(2)}</p>
              </td>
            </tr>
          </tfoot>
        </table>
      ) }
      {tableView === 'THINGS' &&  (
        <table className="table hover">
          <thead className="clientContract-table-head">
            <tr>
              <th className="clientContract-table-col min" scope="col">
                <p>Наименование</p>
              </th>
              <th className="clientContract-table-col" scope="col">
                <p>Модель</p>
              </th>
              <th className="clientContract-table-col" scope="col">
                <p>IMEI</p>
              </th>
              <th className="clientContract-table-col" scope="col">
                <p>S/N</p>
              </th>
              {
                accessFeatures['things.additional_info'] &&
                <th className="clientContract-table-col" scope="col">
                  <p>Доп. описание</p>
                </th>
              }
              <th className="clientContract-table-col" scope="col">
                <p>
                  Оценочная <br />
                  стоимость, руб.
                </p>
              </th>
              <th className="clientContract-table-col" scope="col">
                <p>Количество</p>
              </th>
              <th className="clientContract-table-col" scope="col">
                <p>
                  Сумма <br />
                  микрозайма, руб.
                </p>
              </th>
              <th className="clientContract-table-col" scope="col">
                <p>
                  Сумма <br />к возврату, руб.
                </p>
              </th>
            </tr>
          </thead>
          <tbody className="clientContract-table-body">
            {check &&
              clientContract.positions.map((i, ind) => (
                <tr key={i.names[0] + ind}>
                  <td>
                    <p>{i.names[0]}</p>
                  </td>
                  <td>
                    <p>{i.model || '-'}</p>
                  </td>
                  <td>
                    <p>{i.imei || '-'}</p>
                  </td>
                  <td>
                    <p>{i.serialNumber || '-'}</p>
                  </td>
                  {
                    accessFeatures['things.additional_info'] &&
                    <td>
                      <p>{i.additionalInfo || '-'}</p>
                    </td>
                  }
                  <td>
                    <p>{clientContract.totalEstimatedValue.toFixed(2)}</p>
                  </td>
                  <td>
                    <p>{i.quantity}</p>
                  </td>
                  <td></td>
                  <td></td>
                </tr>
              ))}
            {
                accessFeatures['deal.additional_info'] &&
                <tr className={'clientContract-table-row'}>
                  <td colSpan={'5'} className={`clientContract-table-col`} >
                    <div className={'clientContract-table-td d-flex'}>
                      <p>Комментарий</p>
                      <span className={`clientContract-table-col-arrow${
                          isVisible ? '-up' : ''}`}>
                          <Arrow onClick={() => changeVisible()} />
                      </span>
                    </div>
                  </td>
                </tr>
            }
            <tr className={'clientContract-table-row'}>
              <td  colSpan={'8'}>
                <div className={`clientContract-table-line${
                    isVisible ? '-visible' : ''
                }`}>
                  <p className='clientContract-text'>{clientContract.additionalInformation}</p>
                </div>
              </td>
            </tr>
          </tbody>
          <tfoot className="clientContract-table-foot">
            <tr>
              <td colSpan={accessFeatures['things.additional_info'] ? 5 : 4}>
                <p>Итого</p>
              </td>
              <td>
                <p>
                  {clientContract?.totalEstimatedValue &&
                    clientContract.totalEstimatedValue.toFixed(2)}
                </p>
              </td>
              <td>
                <p>{check && clientContract.positions[0].quantity}</p>
              </td>
              <td>
                <p>{clientContract?.amount && clientContract.amount.toFixed(2)}</p>
              </td>
              <td>
                <p>{clientContract?.refundAmount && clientContract.refundAmount.toFixed(2)}</p>
              </td>
            </tr>
          </tfoot>
        </table>
      )}
      { tableView === 'CARS' && (
        <ContractForCarsLayout
          check={check}
          clientContract={clientContract}
        />
      )}
    </>
  );
};

export default TableLayout;
